import pick from 'lodash/pick';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { recievePayPalAccessToken, recievePayPalSignupLink, recievePayPalMerchantStatus } from '../../ducks/paypalDuck';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/PayPalPayoutPage/SET_INITIAL_VALUES';

// ================ Reducer ================ //

const initialState = {
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaved: false,
  fromReturnURL: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});


// ================ API functions ================ //

const serializeError = (e) => {
   return { status: 'failed', error_message: e.message, data: e.data };
}

// TODO: move this elsewhere as it's used not only in paypal payout page at this point
export const getAccessToken = async () => {
   try {
      return await recievePayPalAccessToken();  
   } catch (error) {
      return serializeError(error);
   }
};

export const getSignupLink = async (data, token) => {
   try {
      return await recievePayPalSignupLink(data, token);  
   } catch (error) {
      return serializeError(error);
   }
};

export const getMerchantStatus = async (token, merchantId) => {
   try {
      return await recievePayPalMerchantStatus(token, merchantId);  
   } catch (error) {
      return serializeError(error);
   }
};

// ================ end API functions ================ //

export const loadData = () => (dispatch, getState, sdk) => {
  // Clear state so that previously loaded data is not visible
  // in case this page load fails.
  dispatch(setInitialValues());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(response => {
    const currentUser = getState().user.currentUser;
   // should fetch PayPal account here
   //  if (currentUser && currentUser.stripeAccount) {
   //    dispatch(fetchStripeAccount());
   //  }
    return response;
  });
};
